<template>
  <div class="p-2 bg-white dark:border-gray-800 rounded-md shadow-md mt-4">
    <!-- Выбранное изображение -->
    <Carousel
      v-if="images.length > 0"
      :value="images"
      :numVisible="1"
      :numScroll="1"
    >
      <template #item="itemProps">
        <Image alt="Image" preview>
          <template #previewicon>
            <i class="pi pi-search"></i>
          </template>
          <template #image>
            <img :src="itemProps.data.url" alt="image" />
          </template>
          <template #preview="previewProps">
            <img
              :src="itemProps.data.url"
              alt="preview"
              :style="previewProps.style"
              @click="previewProps.onClick"
            />
          </template>
        </Image>
      </template>
    </Carousel>
    <div v-else>Haven't images</div>
    <!--    <div-->
    <!--      v-if="currentMainImage !== null"-->
    <!--      class="mb-4 cursor-pointer"-->
    <!--      @click="openModal(currentImageIndex)"-->
    <!--    >-->
    <!--      <img-->
    <!--        :src="currentMainImage"-->
    <!--        alt="Main Image"-->
    <!--        class="w-full h-48 object-cover rounded-lg shadow-lg"-->
    <!--      />-->
    <!--      <div class="flex justify-center mb-4">-->
    <!--        <div class="swiper-pagination"></div>-->
    <!--      </div>-->
    <!--    </div>-->

    <!--    &lt;!&ndash; Слайдер &ndash;&gt;-->
    <!--    <swiper-->
    <!--      class="my-swiper"-->
    <!--      :slides-per-view="4"-->
    <!--      :space-between="10"-->
    <!--      grab-cursor="true"-->
    <!--      :modules="[Navigation, Autoplay, Pagination]"-->
    <!--      navigation-->
    <!--      :autoplay="isAutoplayEnabled ? { delay: 3000 } : false"-->
    <!--      loop-->
    <!--      :pagination="{ el: '.swiper-pagination', clickable: true }"-->
    <!--      @slideChange="updateMainImage"-->
    <!--    >-->
    <!--      <swiper-slide-->
    <!--        v-for="(image, index) in images"-->
    <!--        :key="index"-->
    <!--        @click="openModal(index)"-->
    <!--        class="cursor-pointer"-->
    <!--      >-->
    <!--        <img-->
    <!--          v-if="image.thumbnailUrl"-->
    <!--          :src="image.thumbnailUrl"-->
    <!--          :alt="'Thumbnail ' + index"-->
    <!--          class="w-full h-32 object-cover rounded-lg hover:opacity-80"-->
    <!--        />-->
    <!--      </swiper-slide>-->
    <!--    </swiper>-->

    <!--    &lt;!&ndash; Модальное окно &ndash;&gt;-->
    <!--    <div-->
    <!--      v-if="showModal"-->
    <!--      class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-70 z-50 p-2"-->
    <!--    >-->
    <!--      <div class="absolute bottom-64 w-full">-->
    <!--        <button-->
    <!--          @click="closeModal"-->
    <!--          class="absolute top-4 right-4 text-white bg-gray-800 p-2 rounded-full hover:bg-gray-600 z-50"-->
    <!--        >-->
    <!--          ✕-->
    <!--        </button>-->

    <!--        &lt;!&ndash; Стрелочки навигации &ndash;&gt;-->
    <!--        <div-->
    <!--          class="absolute top-4 left-1/2 transform -translate-x-1/2 z-50 flex space-x-4"-->
    <!--        >-->
    <!--          <button-->
    <!--            @click="prevImage"-->
    <!--            class="text-white bg-gray-800 p-3 rounded-full hover:bg-gray-600"-->
    <!--          >-->
    <!--            ◀-->
    <!--          </button>-->
    <!--          <button-->
    <!--            @click="nextImage"-->
    <!--            class="text-white bg-gray-800 p-3 rounded-full hover:bg-gray-600"-->
    <!--          >-->
    <!--            ▶-->
    <!--          </button>-->
    <!--        </div>-->

    <!--        &lt;!&ndash; Функция поворота &ndash;&gt;-->
    <!--        <button-->
    <!--          @click="rotateImage"-->
    <!--          class="absolute top-4 left-4 text-white bg-gray-800 p-3 rounded-full hover:bg-gray-600 z-50"-->
    <!--        >-->
    <!--          ↺-->
    <!--        </button>-->
    <!--      </div>-->
    <!--      <div class="relative">-->
    <!--        &lt;!&ndash; Изображение &ndash;&gt;-->
    <!--        <img-->
    <!--          v-if="currentImage"-->
    <!--          :src="currentImage"-->
    <!--          :style="{ transform: `rotate(${rotationAngle}deg)` }"-->
    <!--          alt="Modal Image"-->
    <!--          class="max-w-full max-h-screen rounded-lg"-->
    <!--        />-->
    <!--      </div>-->
    <!--    </div>-->
  </div>
</template>

<script setup lang="ts">
  import { computed, defineProps, ref, watch } from 'vue';
  import { Swiper, SwiperSlide } from 'swiper/vue';
  import 'swiper/swiper-bundle.css';
  import { Navigation, Autoplay, Pagination } from 'swiper/modules';
  import moment from 'moment/moment';
  import { formatMoney } from '@/helpers/helper';

  interface Image {
    thumbnailUrl: string;
    fullUrl: string;
  }

  const props = defineProps<{
    images: Image[];
  }>();

  const showModal = ref(false);
  const currentImageIndex = ref<number>(0);
  const isAutoplayEnabled = ref(true); // Автопрокрутка включена
  const rotationAngle = ref(0); // Угол поворота изображения

  // Текущее изображение в большом блоке
  const currentMainImage = computed(() =>
    props.images.length > 0 && currentImageIndex.value >= 0
      ? props.images[currentImageIndex.value]?.fullUrl || null
      : null
  );

  const currentImage = computed(() =>
    props.images.length > 0 &&
    currentImageIndex.value >= 0 &&
    currentImageIndex.value < props.images.length
      ? props.images[currentImageIndex.value]?.fullUrl || null
      : null
  );

  const openModal = (index: number): void => {
    if (index >= 0 && index < props.images.length) {
      currentImageIndex.value = index;
      showModal.value = true;
      isAutoplayEnabled.value = false; // Отключаем автопрокрутку
      document.body.classList.add('no-scroll'); // Блокируем прокрутку
    }
  };

  const closeModal = (): void => {
    showModal.value = false;
    rotationAngle.value = 0; // Сбрасываем угол поворота
    isAutoplayEnabled.value = true; // Включаем автопрокрутку
    document.body.classList.remove('no-scroll'); // Включаем прокрутку
  };

  const prevImage = (): void => {
    if (props.images.length > 0) {
      currentImageIndex.value =
        (currentImageIndex.value - 1 + props.images.length) %
        props.images.length;
      rotationAngle.value = 0; // Сбрасываем угол поворота при смене изображения
    }
  };

  const nextImage = (): void => {
    if (props.images.length > 0) {
      currentImageIndex.value =
        (currentImageIndex.value + 1) % props.images.length;
      rotationAngle.value = 0; // Сбрасываем угол поворота при смене изображения
    }
  };

  const rotateImage = (): void => {
    rotationAngle.value = (rotationAngle.value + 90) % 360; // Вращение на 90 градусов
  };

  const updateMainImage = (swiper: any): void => {
    if (
      swiper?.realIndex !== undefined &&
      swiper.realIndex < props.images.length
    ) {
      currentImageIndex.value = swiper.realIndex;
    }
  };

  // Убедимся, что при уничтожении компонента скролл включается
  watch(showModal, (newVal) => {
    if (!newVal) {
      document.body.classList.remove('no-scroll');
    }
  });
</script>

<style scoped>
  .swiper-slide {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .swiper-pagination {
    bottom: 0;
    text-align: center;
    position: relative;
  }
</style>
